const features = [
  {
    icon: 'ri-shield-flash-line',
    title: '高速CDN加速',
    desc: '全球分布式节点部署，智能调度最优线路，确保红桃视频、小蓝视频全平台内容高清秒加载，告别缓冲等待。',
    color: 'primary',
  },
  {
    icon: 'ri-film-line',
    title: '海量正版资源',
    desc: '聚合西瓜视频免费、茄子视频、久久视频、芒果视频等6大品牌，10万+部影视资源持续更新扩容。',
    color: 'accent',
  },
  {
    icon: 'ri-device-line',
    title: '全终端完美适配',
    desc: '手机、平板、电脑等多种设备自适应布局，无需下载安装，浏览器打开即享沉浸式观影。',
    color: 'secondary',
  },
  {
    icon: 'ri-lock-line',
    title: '安全绿色观影',
    desc: '无弹窗、无恶意广告、无强制注册，纯净的观影环境让您专注于内容本身。',
    color: 'primary',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日内容更新',
    desc: '编辑团队全天候更新片库，最新影视综艺第一时间上线，热播内容与卫视同步。',
    color: 'accent',
  },
];

const colorStyles: Record<string, { iconBg: string; iconText: string; border: string }> = {
  primary: { iconBg: 'bg-primary-100', iconText: 'text-primary-600', border: 'border-primary-100' },
  accent: { iconBg: 'bg-accent-100', iconText: 'text-accent-600', border: 'border-accent-100' },
  secondary: { iconBg: 'bg-secondary-100', iconText: 'text-secondary-600', border: 'border-secondary-100' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            平台特色
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            五大核心优势
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            从技术力到内容力，私密视频用心打磨每一处细节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className={`group flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border ${colorStyles[f.color].border} hover:shadow-sm transition-all`}
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-4 ${colorStyles[f.color].iconBg}`}>
                <i className={`${f.icon} text-2xl ${colorStyles[f.color].iconText}`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}